import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  	name: 'cuit'
})
export class CuitPipe implements PipeTransform {

  	transform(value: number | string): string {
		let Valor: string = value.toString();

		if (Valor.length == 11) {
			Valor = `${ Valor.substring(0, 2) }-${ Valor.substring(2, 10) }-${ Valor.substring(10, 11) }`
		}

		return Valor;
  	}

}
